import { useEffect, useState } from "react";

const isStandalone = () => window.matchMedia?.("(display-mode: standalone)").matches || window.navigator.standalone === true;
const isIos = () => /iphone|ipad|ipod/i.test(navigator.userAgent) || (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1);

let deferredPrompt = null;
const listeners = new Set();
const notify = () => listeners.forEach((fn) => fn());
if (typeof window !== "undefined") {
  window.addEventListener("beforeinstallprompt", (e) => { e.preventDefault(); deferredPrompt = e; notify(); });
  window.addEventListener("appinstalled", () => { deferredPrompt = null; notify(); });
}

export const usePwaInstall = () => {
  const [, tick] = useState(0);
  const [standalone, setStandalone] = useState(isStandalone);
  useEffect(() => {
    const fn = () => tick((n) => n + 1);
    listeners.add(fn);
    const mq = window.matchMedia?.("(display-mode: standalone)");
    const onMq = () => setStandalone(isStandalone());
    mq?.addEventListener?.("change", onMq);
    return () => { listeners.delete(fn); mq?.removeEventListener?.("change", onMq); };
  }, []);
  const mode = standalone ? "installed" : deferredPrompt ? "native" : isIos() ? "ios" : "unavailable";
  const install = async () => {
    if (!deferredPrompt) return "unavailable";
    const p = deferredPrompt;
    p.prompt();
    const { outcome } = await p.userChoice;
    deferredPrompt = null;
    notify();
    return outcome;
  };
  return { mode, install };
};
